import ForgotPassword from "../../loginPage/forgotPassword/ForgotPasswordServiceForm";
// import { useDispatch, useSelector } from "react-redux";
// import { submit } from "../../../features/forms/form6";
// import SubmitForm from "../../forms/form6/submitbutton/submitForm";
// import { useForm, FormProvider } from "react-hook-form";
import "../login.css";
import "./forgotpassword.css"
import Footer from "../../forgotPassword/footer";
import Intro from "../intro";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MembersDetails from "../login/members/memberDetails";
import { styles } from "../login/members/member";
function ForgotPasswordScreen() {
    const [forgetPasswordObj, setForgetPasswordObj] = useState({ mobile_number: "", captcha: "", otp: "", newpassword: "", confirmpassword: "",userType:"CS" })
    
    
    // const handlesubmit = (event) => {
    //     event.preventDefault();
    //     console.log(forgetPasswordObj)

    // }
    let navigate = useNavigate();
    const location = useLocation();
    const data = location.state;
    const handlesubmit = (event) => {
        event.preventDefault();
        navigate("/otpforgot", { state:data});
      };
    return (
       <div style={styles.main}>
           <div style={styles.row}>
   
             {/* Left Div - Commissioners */}
             <MembersDetails ></MembersDetails>
               <div style={styles.boxLogin}>
            <div className="form_login">
                        <form onSubmit={handlesubmit} className="form_align">
                            <ForgotPassword
                                forgetPasswordObj={forgetPasswordObj} 
                                setForgetPasswordObj={setForgetPasswordObj}
                            ></ForgotPassword>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        // <div className="container " id="forgotPassword">
        //     <div className="row layout"  >
        //         <div className="col-sm-5 dummy_box_password ">
        //         <div className="dummy_text_password">
        //         <Intro></Intro>
        //         </div>
        //         <div className="footer_pass">
        //        <Footer></Footer>
        //         </div>
        //         </div>
        //         <div className="col-sm-7 form_password" >
        //             <div className="row p-2">
        //             <div className="form_password">
        //                 <form  onSubmit={handlesubmit} className="form_align"> 
        //                     <ForgotPassword forgetPasswordObj={forgetPasswordObj} setForgetPasswordObj={setForgetPasswordObj}></ForgotPassword>
        //                </form>
        //               </div>
        //               </div>
        //         </div>
        //     </div>
        // </div>
    )
}

export default ForgotPasswordScreen;